/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  useEffect(() => {
    document.title = 'Mentions Légales | Yellow Cab Corsica';
  }, []);

  return (
    <main className="bg-[#0A0A0A] min-h-screen pt-8 pb-28 md:pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-[#555] mb-10">
          <Link to="/" className="hover:text-[#A3A3A3] transition-colors">Accueil</Link>
          <span>/</span>
          <span className="text-[#A3A3A3]">Mentions légales</span>
        </div>

        <h1
          className="text-3xl sm:text-4xl font-light text-white tracking-tight mb-10"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Mentions légales
        </h1>

        <div className="prose prose-invert max-w-none space-y-8 text-[#A3A3A3]">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              1. Éditeur du site
            </h2>
            <p className="text-sm leading-relaxed">
              <strong className="text-white">Dénomination commerciale :</strong> Taxis Yellow Cab Corsica<br />
              <strong className="text-white">Forme juridique :</strong> Entrepreneur individuel<br />
              <strong className="text-white">Siège social :</strong> Avenue du Maréchal Moncey, Bât. B6, Rés. Les Palmiers, 20090 Ajaccio, Corse-du-Sud<br />
              <strong className="text-white">SIREN :</strong> 888 339 272<br />
              <strong className="text-white">SIRET :</strong> 888 339 272 00013<br />
              <strong className="text-white">Numéro de TVA intracommunautaire :</strong> FR58888339272<br />
              <strong className="text-white">Activité (NAF/APE) :</strong> Transports de voyageurs par taxis — 4932Z<br />
              <strong className="text-white">Date de création :</strong> 27 août 2020<br />
              <strong className="text-white">Téléphone :</strong> +33 6 74 62 63 68<br />
              <strong className="text-white">Email :</strong> taxiyellowcabcorsica@gmail.com
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              2. Directeur de la publication
            </h2>
            <p className="text-sm leading-relaxed">
              Le directeur de la publication est le gérant de l'entreprise individuelle Taxis Yellow Cab Corsica.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              3. Hébergement
            </h2>
            <p className="text-sm leading-relaxed">
              Ce site est hébergé par :<br />
              <strong className="text-white">Société :</strong> Emergent Labs Inc.<br />
              <strong className="text-white">Site web :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#EAB308] hover:underline">emergent.sh</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              4. Propriété intellectuelle
            </h2>
            <p className="text-sm leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de Taxis Yellow Cab Corsica, sauf mention contraire. Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces éléments est strictement interdite sans l'accord écrit préalable de Taxis Yellow Cab Corsica.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              5. Limitation de responsabilité
            </h2>
            <p className="text-sm leading-relaxed">
              Taxis Yellow Cab Corsica s'efforce de maintenir les informations contenues sur ce site aussi précises et à jour que possible, mais ne peut garantir leur exactitude, exhaustivité ou actualité. Taxis Yellow Cab Corsica ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation de ce site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              6. Protection des données personnelles
            </h2>
            <p className="text-sm leading-relaxed">
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi n°78-17 du 6 janvier 1978 (Loi Informatique et Libertés), vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition aux données vous concernant. Pour exercer ces droits, veuillez consulter notre{' '}
              <Link to="/politique-de-confidentialite" className="text-[#EAB308] hover:underline">
                Politique de confidentialité
              </Link>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              7. Droit applicable
            </h2>
            <p className="text-sm leading-relaxed">
              Le présent site est soumis au droit français. En cas de litige, les tribunaux compétents seront ceux du ressort du siège social de Taxis Yellow Cab Corsica.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/8">
          <Link to="/" className="text-[#EAB308] text-sm hover:underline">
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </main>
  );
};

export default MentionsLegales;
